import { UserBalance } from "../../models/models";
import { getEmptyUser } from './User';

export function getEmptyClient(): UserBalance
{
		let user = getEmptyUser();
		user.type = 'CLIENT';
		user.start_order_amount = 0;
		user.start_order_paid = 0;
		return user;
}
